import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const parallel = defineConnector({
  identifier: "parallel",
  name: "Parallel",
  tagLine: "Web search and research APIs for AI",
  logo,
  protocol: "http",
  tags: ["ai", "data"],
  defaultUrlPattern: () => "https://api\\.parallel\\.ai/.*",
  auth: (app) => headerAuth([{ name: "x-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Create an API key in the [Parallel Platform](https://platform.parallel.ai/settings?tab=api-keys), then follow the [Search API quickstart](https://docs.parallel.ai/search/search-quickstart) if you need setup help.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.parallel.ai/v1/search",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        search_queries: ["test"],
        mode: "turbo",
        advanced_settings: { max_results: 1 },
      }),
    }),
  },
});
